import config from "@/common/config";

import ApiService from "./api.service";

export const ATTACHMENT_ALLOWED_EXT = [
  // Apple Pages
  "pages",
  // OpenDocument
  "odt",
  // Microsoft Word 6.0/95/97/2000/XP
  "doc",
  // Microsoft Word 2007 XML
  "docx",
  // WordPerfect Document
  "wpd",
  // Plain text
  "rtf",
  "txt",
  // Presentation
  "pdf",
  // Images
  "png",
  "jpg",
  "jpeg",
  // Video file formats
  "gif",
  "mp4",
  "mov",
  "mpg",
  "mpeg"
];

export default {
  VERSION: config.api.versions.v2,

  /**
   * Submits form data to backend to send as an email.
   *
   * @param {FormData} formData
   */
  submit(formData) {
    return ApiService.post("/support", formData, this.VERSION);
  }
};
